import React from "react";
import "./text.css";

const GradientText = ({
  tag: Tag = "div",
  text,
  additionalclasses = "",
  style = {},
}) => {
  return (
    <Tag style={style} className={`gradient-heading ${additionalclasses}`}>
      {text}
    </Tag>
  );
};

export default GradientText;
